import { get } from 'lodash';
import pubsub from 'sweet-pubsub';

const show = (toast) => pubsub.emit('toast', toast);

const success = (title) => show({ title });

const error = (err, title = 'Error') => {
  show({
    duration: 0,
    message: get(err, 'message', err),
    title,
    type: 'danger',
  });
};

export default { error, show, success };
